import { createFileRoute } from '@tanstack/react-router';
import { PlumberManager } from '~/components/dashboards/plumber/PlumberManager';

export const Route = createFileRoute('/_app/plumber-manager')({
  component: PlumberManager,
});

/**
 * Plumber Manager — top-level section (moved out of Sales per owner). The
 * plumber-referral CRM. The component owns the whole page (heading + `pdq-tabs`
 * strip + content) so its tab structure matches the other dashboard sections —
 * see `~/components/dashboards/plumber/PlumberManager` for the tab breakdown.
 * It reads `plumbers` / `plumber_contacts` (migrations 0079 + 0118 + 0129) and
 * shows an empty state until those migrations are applied.
 */
